import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesUntaxedWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.untaxed",
  name: "Untaxed sales",
  description: "Untaxed sales for the selected dashboard period.",
  apps: [
    "home",
    "sales",
    "crm",
    "finance",
    "invoicing",
    "point-of-sale",
    "subscriptions",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "untaxed_amount",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Untaxed sales",
    subtext: "in the last 30 days",
    icon: "money",
    color: "primary",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "0",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
